import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/auth/services/auth.service';
import { MessageService } from 'primeng/api';


@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    private readonly messageService = inject(MessageService);

    constructor(private readonly auth: AuthService, private readonly router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.auth.isLoggedIn()) return true;

        const url = state?.url || '/criar-campanha';
        this.router.navigate(['/auth/login'], {
            queryParams: { returnUrl: url }
        });
        return false;
    }
}

